export const signUpForFreeTrialAccount = () => {
  const domain = process.env.NEXT_PUBLIC_XD2SKETCH_AUTH0_DOMAIN;
  const backupApi = process.env.NEXT_PUBLIC_XD2SKETCH_BACKUP_API_URL;

  const params = new URLSearchParams({
    client_id: process.env.NEXT_PUBLIC_XD2SKETCH_AUTH0_CLIENT_ID ?? "",
    scope: "openid profile email",
    response_type: "token",
    screen_hint: "signup",
    response_mode: "form_post",
    redirect_uri: `${backupApi}/user/try-for-free`,
  });

  window.open(`${domain}/authorize?${params}`, "_blank");
};
